/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { CmlContent } from '__generated__/graphql-types';

import TogglableContent from 'bundles/page/components/TogglableContent';
import CML from 'bundles/unified-description-page-common/components/shared/CML';
import ToggleButtonForStreamlinedMWebTogglableContent from 'bundles/unified-description-page-common/components/shared/ToggleButtonForStreamlinedMWebSyllabusDescription';
import ToggleButtonForTogglableContent from 'bundles/unified-description-page-common/components/shared/ToggleButtonForTogglableContent';

const COLLAPSED_HEIGHTS = {
  fullyCollapsed: 0,
  default: 65,
};

const styles = {
  container: css`
    white-space: pre-wrap;
  `,
  overrideStyles: css`
    .toggle-button-wrapper span {
      color: var(--cds-color-interactive-primary);
    }
  `,
  mWebContainer: css`
    .about-section {
      margin-top: calc(var(--cds-spacing-400) * -1);
      padding-bottom: var(--cds-spacing-200);

      .content-inner {
        margin-top: var(--cds-spacing-300);
      }
    }
  `,
};

type Props = {
  productId?: string;
  description?: string | null;
  cmlDescription?: CmlContent | null;
  trackingName?: string;
  collapsedHeight?: number;
};

const TogglableDescription = ({
  productId,
  description,
  cmlDescription,
  trackingName,
  collapsedHeight = COLLAPSED_HEIGHTS.default,
}: Props) => {
  const isFullyCollapsed = collapsedHeight === COLLAPSED_HEIGHTS.fullyCollapsed;

  if (!description && !cmlDescription) {
    return null;
  }

  return (
    <div css={[styles.container, styles.overrideStyles, isFullyCollapsed ? styles.mWebContainer : '']}>
      <TogglableContent
        childrenWrapperTag="div"
        className="about-section"
        collapsedHeight={collapsedHeight}
        disableCollapseScroll
        renderToggleButtonContentFunction={
          isFullyCollapsed ? ToggleButtonForStreamlinedMWebTogglableContent : ToggleButtonForTogglableContent
        }
        toggleButtonClassName="bold body-2-text"
        toggleButtonType="button"
        useSmartCollapse
        trackingName={trackingName ?? 'description'}
        {...(productId ? { trackingData: { courseId: productId } } : {})}
      >
        {cmlDescription ? <CML cml={cmlDescription} /> : description}
      </TogglableContent>
    </div>
  );
};

export default TogglableDescription;
